<template>
    <div>
        <v-row justify="center" class="ma-16">
            <v-col cols="12">
                <p class="text-h3 text-center">Panel Administratora</p>
            </v-col>
        </v-row>
        <v-row justify="center" class="justify-center ma-16">
            <v-col cols="12" lg="4">
                <v-hover v-slot="{ isHovering, props }">
                <v-card v-bind="props" variant="outlined" max-width="500">
                    <div class="align-end pa-10" height="500px">
                        <v-card-title class="text-h4 text-center">Zamówienia</v-card-title>
                        <v-overlay
                            :model-value="isHovering"
                            contained
                            class="align-center justify-center"
                        >
                            <v-btn
                            size="x-large"
                            color="primary"
                            @click="$router.push('/AdminOrders')"
                            >
                            Sprawdź
                            </v-btn>
                        </v-overlay>
                    </div>
                </v-card>
                </v-hover>
            </v-col>
            <v-col cols="12" lg="4">
                <v-hover v-slot="{ isHovering, props }">
                <v-card v-bind="props" variant="outlined" max-width="500">
                    <div class="align-end pa-10" height="500px">
                        <v-card-title class="text-h4 text-center">Kody rabatowe</v-card-title>
                        <v-overlay
                            :model-value="isHovering"
                            contained
                            class="align-center justify-center"
                        >
                            <v-btn
                            size="x-large"
                            color="primary"
                            @click="$router.push('/AdminCoupons')"
                            >
                            Sprawdź
                            </v-btn>
                        </v-overlay>
                    </div>
                </v-card>
                </v-hover>
            </v-col>
            <v-col cols="12" lg="4">
                <v-hover v-slot="{ isHovering, props }">
                <v-card v-bind="props" variant="outlined" max-width="500">
                    <div class="align-end pa-10" height="500px">
                        <v-card-title class="text-h4 text-center">Stan Magazynowy</v-card-title>
                        <v-overlay
                            :model-value="isHovering"
                            contained
                            class="align-center justify-center"
                        >
                            <v-btn
                            size="x-large"
                            color="primary"
                            @click="$router.push('/AdminStorage')"
                            >
                            Sprawdź
                            </v-btn>
                        </v-overlay>
                    </div>
                </v-card>
                </v-hover>
            </v-col>
        </v-row>
        <v-row align="end" justify="center">
            <v-btn color="primary" @click="logoutclick()">Wyloguj</v-btn>
        </v-row>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    data () {
      return {
      }
    },
    computed: {
        ...mapGetters(['isLoggedIn'])
    },
    created() {
      if(this.isLoggedIn !== true){
        this.$router.push('/AdminLogin')
      }
    },
    methods: {
      ...mapActions([
        'logout',
      ]),
      logoutclick() {
        this.logout();
        this.$router.push('/AdminLogin')
      }
    }
}
</script>